import { createSlice } from "@reduxjs/toolkit"
import { RootState } from "./store"

export enum ApplicationStatus {
    LOADING,
    RUNNING,
    ERROR,
    CLOSING,
    CLOSED
}

export interface ApplicationState {
    status: ApplicationStatus
    previousStatus?: ApplicationStatus
    idToken?: string
    assignedAgent?: string
    loginUrl?: string
    loginUrlExpire?: string
    numberLeaseExpire?: string
    phoneNumber?: string
    renewalAuthCode?: string
}

const initialState: ApplicationState = {
    status: ApplicationStatus.LOADING
}

export const appSlice = createSlice(
    {
        name: 'chc-anonymizer-utility',
        initialState,
        reducers: {
            setIdToken: (state, action) => { state.idToken = action.payload},
            setAssignedAgent: (state, action) => { state.assignedAgent = action.payload},
            setLoginUrl: (state, action) => { state.loginUrl = action.payload },
            setLoginUrlExpire: (state, action) => { state.loginUrlExpire = action.payload},
            setNumberLeaseExpire: (state, action) => { state.numberLeaseExpire = action.payload},
            setPhoneNumber: (state, action) => { state.phoneNumber = action.payload},
            setRenewalAuthCode: (state, action) => { state.renewalAuthCode = action.payload},
            setStatus: (state, action) => { state.status = action.payload},
            setPreviousStatus: (state, action) => { state.previousStatus = action.payload }
        }
    }
)

export const getIdToken = (state: RootState) => state.application.idToken;
export const getAssignedAgent = (state: RootState) => state.application.assignedAgent;
export const getLoginUrl = (state: RootState) => state.application.loginUrl;
export const getLoginUrlExpire = (state: RootState) => state.application.loginUrlExpire;
export const getNumberLeaseExpire = (state: RootState) => state.application.numberLeaseExpire;
export const getPhoneNumber = (state: RootState) => state.application.phoneNumber;
export const getRenewalAuthCode = (state: RootState) => state.application.renewalAuthCode;
export const getStatus = (state: RootState) => state.application.status;
export const getPreviousStatus = (state: RootState) => state.application.previousStatus || undefined;

export const { 
    setStatus, setPreviousStatus, setIdToken,
    setAssignedAgent, setLoginUrl, setLoginUrlExpire,
    setNumberLeaseExpire, setPhoneNumber, setRenewalAuthCode } = appSlice.actions;
export default appSlice.reducer;